import { AuthLayout } from '@/components/layouts/AuthLayout/AuthLayout';
import { Head } from '@/components/seo/Head/Head';
import { Button } from '@/components/ui/Button/Button';
import { paths } from '@/config/paths';
import { LoginForm } from '@/features/auth/components/LoginForm/LoginForm';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

export const LoginRoute = () => {
  const { t } = useTranslation('auth', { keyPrefix: 'login' });

  return (
    <>
      <Head title={t('seo.title')} />
      <AuthLayout illustration='ace-workout'>
        <div className='flex w-full max-w-[400px] flex-col gap-8'>
          <h1 className='text-heading-l-semibold'>{t('title')}</h1>
          <LoginForm />
          <div className='flex gap-6'>
            <Button asChild variant='link' className='text-text-brand-primary px-0'>
              <Link to={paths.auth.forgotPassword.getHref()}>{t('forgotPassword')}</Link>
            </Button>
            <Button asChild variant='link' className='text-text-brand-primary px-0'>
              <Link to={paths.auth.forgotUsername.getHref()}>{t('forgotUsername')}</Link>
            </Button>
          </div>
        </div>
      </AuthLayout>
    </>
  );
};
